"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var window_exports = {};
__export(window_exports, {
  WindowImpl: () => WindowImpl
});
module.exports = __toCommonJS(window_exports);
class WindowImpl {
  constructor(result, total, isTail, isHead, query) {
    this.result = result;
    this.total = total;
    this.isTail = isTail;
    this.isHead = isHead;
    this.query = query;
  }
  static {
    __name(this, "WindowImpl");
  }
  getResult() {
    return this.result;
  }
  getTotal() {
    return this.total;
  }
  async loadNextPage() {
    if (!this.hasNextPage()) return;
    await this.query.requestLoadNextPage();
  }
  async loadPrevPage() {
    if (!this.hasPrevPage()) return;
    await this.query.requestLoadPrevPage();
  }
  hasNextPage() {
    return !this.isTail;
  }
  hasPrevPage() {
    return !this.isHead;
  }
}
//# sourceMappingURL=window.js.map
